import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  inject
} from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { from } from 'rxjs';
import { File as FileModel } from 'src/app/classes/models';
import { ContractService } from 'src/app/services/contract.service';
import { ToastService } from 'src/app/services/toast.service';
import { UtilityService } from 'src/app/services/utility.service';

@Component({
  selector: 'app-contract-file-upload-modal',
  templateUrl: './contract-file-upload-modal.component.html',
  styleUrls: ['./contract-file-upload-modal.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ContractFileUploadModalComponent {
  @Input() Files: FileModel[] = [];
  @Input() ContractId?: number;

  private _cdr = inject(ChangeDetectorRef);

  constructor(
    private activeModal: NgbActiveModal,
    private UtilityService: UtilityService,
    private ContractService: ContractService,
    private ToastService: ToastService
  ) {}

  continue() {
    this.activeModal.close(this.Files);
  }

  close() {
    this.activeModal.close(false);
  }

  fileUpload({ data: File }: { data: File }) {
    if (this.Files.length >= 2) {
      throw this.ToastService.addErrorToast(
        'Error',
        'Cannot upload more than 15 files.',
        { returnError: true }
      );
    }

    const { name: filename, size: filesize, type: filetype } = File;
    const fileAlreadyUploaded = this.Files.find(
      (file) => file.filename === filename
    );

    if (fileAlreadyUploaded) {
      throw this.ToastService.addErrorToast(
        'Error',
        'Cannot upload file. File already exists in file list.',
        { returnError: true }
      );
    }

    from(File.arrayBuffer()).subscribe({
      next: (FileArrayBuffer) => {
        const FileString = `data:${filetype};base64,${this.UtilityService.convertArrayBufferToBase64EncodedString(FileArrayBuffer)}`;

        const uploadedFile = {
          filename,
          filesize,
          filetype,
          FileContent: {
            filecontents: FileString
          }
        };

        this.Files.push(uploadedFile);
        this._cdr.markForCheck();
      }
    });
  }

  removeFile({ index }: { index: number }) {
    if (this.ContractId) {
      const contractFile = this.Files.splice(index, 1)[0];
      const { id: FileId } = contractFile;

      if (FileId) {
        this.ContractService.deleteContractFile(
          this.ContractId,
          FileId
        ).subscribe();
      }
    }
    this.Files.splice(index, 1);
    this._cdr.markForCheck();
  }
}
